import * as React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import GiftCardsIframe from '.';

export const paths = {
  giftCards: '/gift-cards',
  settings: '/gift-cards/settings',
  view: '/gift-cards/:id',
  new: '/gift-cards/new',
};

export default [
  <RouteIfRights
    exact
    path={paths.giftCards}
    key={paths.giftCards}
    component={GiftCardsIframe}
    rights="customers_read"
    modules="omni.giftcards"
  />,
  <RouteIfRights
    exact
    path={paths.view}
    component={GiftCardsIframe}
    key={paths.view}
    rights="customers_read"
    modules="omni.giftcards"
  />,
  <RouteIfRights
    exact
    path={paths.settings}
    component={GiftCardsIframe}
    key={paths.settings}
    rights="customers_read"
    modules="omni.giftcards"
  />,
  <RouteIfRights
    exact
    path={paths.new}
    component={GiftCardsIframe}
    key={paths.new}
    rights="customers_read"
    modules="omni.giftcards"
  />,
];
